// @erp/module-audit/schemas — the AUDIT grant matrix. Browser-safe: types +
// plain data only (fe/useCan and the gateway's rbac() evaluate the SAME map
// through can(), so UI affordance and server enforcement can never disagree).
//
// Capability family — deliberately READ-ONLY. There is no audit:write and there
// never will be: the ONLY writer is the tier-1 gateway middleware, and rows are
// append-only (Law A1). There is no audit:delete either — retention is partition
// detach, never a row-level DELETE (ADR-004 §8).
//
//   audit:read  — the WHOLE installation's trail (the admin tier).
//
// THE MODULE-SCOPED READER RULE is deliberately NOT a grant — it is the exact
// shape modules/fin's allowedToVerify already uses: reading the trail of a row
// whose module = m is allowed to holders of audit:read OR m:admin. A librarian
// holding lib:admin therefore reads the LIBRARY trail without holding any
// audit:* capability, and an unfiltered feed AUTO-SCOPES to their modules
// (auditScope in api/service.ts, the verifierScope precedent). An OR-tier no
// single rbac(perm) can express, so it is enforced in-service via the injected
// can().
//
// Merge law: compose with the core seed via mergeGrants(ROLE_GRANTS, AUDIT_GRANTS)
// — NEVER an object spread (the LIB anti-clobber law).
import type { RoleGrants } from "@erp/auth-kit/rbac";

export const AUDIT_GRANTS: RoleGrants = {
  owner: ["audit:*"],
  admin: ["audit:*"],
};

/**
 * Every capability that admits a session to the audit console (any one
 * suffices — the CMS_CONSOLE_PERMS precedent). Module-scoped readers
 * (m:admin without audit:read) reach the trail through their own module's
 * record screens, not through this console entry, so no module perms appear here.
 */
export const AUDIT_CONSOLE_PERMS = ["audit:read"] as const;
